import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CurriculumsService {
  private http = inject(HttpClient);

  getCurriclums(): Observable<any> {
    return this.http.get(`${environment.apiUrl}api/website/curriclums/filter`);
  }
}
